import React from 'react';
import styled from '@emotion/styled';
import { node, oneOfType, shape, string } from 'prop-types';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

/**
 * Horizontal Stack component.
 * @example
 * <HStack>
 *   <div>Hello</div>
 *   <div>World</div>
 * </HStack>
 */
const HStack = ({
  children,
  top,
  right,
  bottom,
  left,
  align,
  height,
  justify,
  padding,
  style,
  width,
  ...props
}) => {
  const styHStack = {
    alignItems: align,
    height,
    justifyContent: justify,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    padding,
    width,
    ...style,
  };

  return (
    <StyledDiv style={styHStack} {...props}>
      {children}
    </StyledDiv>
  );
};

HStack.propTypes = {
  children: oneOfType([node, string]), // React.ReactNode
  top: string, // CSS.Property.MarginTop
  right: string, // CSS.Property.MarginRight
  left: string, // CSS.Property.MarginLeft
  bottom: string, // CSS.Property.MarginBottom
  align: string, // CSS.Property.AlignItems
  height: string, // CSS.Property.Height
  justify: string, // CSS.Property.JustifyContent
  padding: string, // CSS.Property.Padding
  style: shape({}), // CSS.Property
  width: string, // CSS.Property.Width
};

HStack.defaultProps = {
  children: null,
  top: '',
  right: '',
  left: '',
  bottom: '',
  align: '',
  height: '',
  justify: '',
  padding: '',
  style: {},
  width: '',
};

export default HStack;
